import LongText from '../Elements/LongText';
import React from 'react';
import urlHelper from '../Helpers/urlHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import JsxHelper from '../Helpers/JsxHelper';

export default class TpClientPaymentItem {
  constructor(item) {
    if (item) {
      this.TpClientPaymentId = item.tpClientPaymentId;
      this.ClientName = item.clientName;
      this.Type = item.type;
      this.EntryDateUtc = item.entryDateUtc;
      this.CheckNumber = item.checkNumber;
      this.AmountPaid = item.amountPaid;
      this.Balance = item.balance;
      this.IsReversed = item.isReversed;
      this.CurrencyCode = item.currencyCode;
      this.CurrencySymbol = item.currencySymbol;
      this.PaymentInstrumentDateUtc = item.paymentInstrumentDateUtc;
      this.CurrencyId = item.currencyId;
      this.ReceivingOfficeName = item.receivingOfficeName;
      this.Notes = item.notes;
      this.AmountApplied = item.amountApplied;
      this.Status = item.status;
      this.AmountRefunded = item.amountRefunded;
      this.IsPrepayment = item.isPrepayment;
      this.PrepaymentTpClientInvoiceId = item.prepaymentTpClientInvoiceId;
      this.InversePrepaymentTpClientPaymentId = item.inversePrepaymentTpClientPaymentId;
      this.AnyCreatedPrepaymentsNotReversed = item.anyCreatedPrepaymentsNotReversed;
      this.AppliedOn = item.appliedOn;
      this.AppliedToInvoiceId = item.appliedToInvoiceId;

      this.Selected = false;
      return;
    }
    this.TpClientPaymentId = '';
    this.ClientName = '';
    this.Type = '';
    this.EntryDateUtc = '';
    this.CheckNumber = '';
    this.AmountPaid = '';
    this.Balance = '';
    this.IsReversed = '';
    this.CurrencyCode = '';
    this.CurrencySymbol = '';
    this.PaymentInstrumentDateUtc = '';
    this.CurrencyId = '';
    this.ReceivingOfficeName = '';
    this.Notes = '';
    this.AmountApplied = '';
    this.Status = '';
    this.AmountRefunded = '';
    this.IsPrepayment = '';
    this.PrepaymentTpClientInvoiceId = '';
    this.InversePrepaymentTpClientPaymentId = '';
    this.AnyCreatedPrepaymentsNotReversed = false;
    this.AppliedOn = '';
    this.AppliedToInvoiceId = '';

    this.Selected = false;
  }

  static MoneyFields = ['AmountPaid', 'Balance', 'AmountApplied', 'AmountRefunded'];
  static DateFields = ['EntryDateUtc', 'PaymentInstrumentDateUtc', 'AppliedOn'];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = ['AmountPaid', 'Balance', 'AmountApplied', 'AmountRefunded'];
  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static nameOfTheItemDetailList() {
    return 'Client Payment';
  }

  // static serviceFunctionForListTable = (item) => TpClientPaymentService.GetByPaymentById(item.TpClientPaymentId);

  static FieldsToShowInListTable = [
    {
      data: [
        { name: '-message-', label: 'General Information', className: 'text-left' },
        { label: 'Client', name: 'ClientName', className: 'text-left' },
        { label: 'Payment Method', name: 'Type', className: 'text-left' },
        {
          label: 'Entry Date',
          name: (item) => (item.EntryDateUtc ? dateTimeHelper.toYYYYsMMsDD(item.EntryDateUtc, '/') : ''),
          className: 'text-left',
        },
        { label: 'Receiving Office', name: 'ReceivingOfficeName', className: 'text-left' },
        { label: 'Payment Reference #', name: 'CheckNumber', className: 'text-left' },
        {
          label: 'Payment Instrument Date',
          name: (item) =>
            item.PaymentInstrumentDateUtc ? dateTimeHelper.toYYYYsMMsDD(item.PaymentInstrumentDateUtc, '/') : '',
          className: 'text-left',
        },
        { label: 'Amount Paid', name: 'AmountPaid', className: 'text-left' },
        {
          label: 'Notes',
          name: 'Notes',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
          contentHasHtml: true,
        },
        { label: 'Applied', name: 'AmountApplied', className: 'text-left' },
        { label: 'Status', name: 'Status', className: 'text-left' },
        { label: 'Reversed?', name: (item) => JsxHelper.YesNo(item.IsReversed), className: 'text-left' },
        { label: 'Refunded', name: 'AmountRefunded', className: 'text-left' },
        { label: 'Prepayment?', name: (item) => JsxHelper.YesNo(item.IsPrepayment), className: 'text-left' },
        {
          label: 'Prepayment ID',
          name: TpClientPaymentItem.getPrepaymentCellContent,
          className: 'text-left',
        },
        { label: 'Remaining Balance', name: 'Balance', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: TpClientPaymentItem.getSelectedCellHeader,
        orderById: '',
        data: TpClientPaymentItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'TP Client Payment ID',
        orderById: 'TpClientPaymentId',
        data: TpClientPaymentItem.GetDetailCellContent,
        minWidth: 20,
      },
      { label: 'Client', orderById: 'ClientName', data: TpClientPaymentItem.getClientCellContent, minWidth: 40 },
      {
        label: 'Payment Method',
        orderById: 'Type',
        data: 'Type',
        minWidth: 20,
      },
      {
        label: 'Entry Date',
        orderById: 'EntryDateUtc',
        data: 'EntryDateUtc',
        minWidth: 40,
      },
      {
        label: 'Payment Reference #',
        orderById: 'CheckNumber',
        data: TpClientPaymentItem.getPaymentReferenceCellContent,
        minWidth: 20,
      },
      { label: 'Amount Paid', orderById: 'AmountPaid', data: 'AmountPaid', minWidth: 20 },
      { label: 'Remaining Balance', orderById: 'Balance', data: 'Balance', minWidth: 20 },
      {
        label: 'Prepayment?',
        orderById: 'IsPrepayment',
        data: (item) => JsxHelper.YesNo(item.IsPrepayment),
        minWidth: 20,
      },
      {
        label: 'Reversed?',
        orderById: 'IsReversed',
        data: (item) => JsxHelper.YesNo(item.IsReversed),
        minWidth: 20,
      },
      {
        label: ' ',
        orderById: '',
        data: TpClientPaymentItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getPaymentReferenceCellContent(item) {
    return (
      <LongText
        text={item.CheckNumber ? item.CheckNumber : ' '}
        maxLength={120}
      />
    );
  }

  static getClientCellContent(item) {
    return (
      <LongText
        text={item.ClientName ? item.ClientName : ' '}
        maxLength={80}
      />
    );
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.TpClientPaymentId,
      '',
      '',
      'new_clientpaymentdetails',
      `id=${item.TpClientPaymentId}`,
      'Open up in a new tab'
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Refund',
            iconName: 'fa-solid fa-money-bill-transfer',
            roleKey: 'tp_clientpayment_refund',
            onClick: () => TpClientPaymentItem.refundFunction(item.CiId, item),
            disabled: item.Balance <= 0 || item.IsReversed || item.AnyCreatedPrepaymentsNotReversed,
          },
          {
            text: 'Reverse',
            iconName: 'fa-solid fa-clock-rotate-left',
            roleKey: 'tp_clientpayment_reverse',
            onClick: () => TpClientPaymentItem.reverseFunction(item.CiId, item),
            disabled: item.AmountRefunded > 0 || item.IsReversed || item.AnyCreatedPrepaymentsNotReversed,
          },
        ]}
      />
    );
  }

  static refundFunction(id, item) {
    alert('Empty function!');
  }

  static reverseFunction(id, item) {
    alert('Empty function!');
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          TpClientPaymentItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={TpClientPaymentItem.selectedStatus()}
        onChange={(e) => {
          TpClientPaymentItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getPrepaymentCellContent(item) {
    if (item.PrepaymentTpClientInvoiceId)
      return urlHelper.getIconLinkComponentFigma(
        `${item.PrepaymentTpClientInvoiceId}`,
        'fa-solid fa-arrow-up-right-from-square',
        'text-primary pl-1 pr-1',
        'new_finance_clientpayment/search',
        `OfficeIds=&PaymentListType=all&TpClientPaymentId=${item.PrepaymentTpClientInvoiceId}`,
        'Open payment on a new tab'
      );
    if (item.InversePrepaymentTpClientPaymentId)
      return urlHelper.getIconLinkComponentFigma(
        `${item.InversePrepaymentTpClientPaymentId}`,
        'fa-solid fa-arrow-up-right-from-square',
        'text-primary pl-1 pr-1',
        'new_finance_clientpayment/search',
        `OfficeIds=&PaymentListType=all&TpClientPaymentId=${item.InversePrepaymentTpClientPaymentId}`,
        'Open payment on a new tab'
      );
  }
}
